import React, { useEffect, useRef } from 'react';
import LargeLogo from '../../assets/images/Logo Large.png';

const HeroSection: React.FC = () => {
  const parallaxRef = useRef<HTMLDivElement>(null);
  
  // Parallax effect for the background
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!parallaxRef.current) return;
      
      const x = (window.innerWidth - e.pageX * 2) / 100;
      const y = (window.innerHeight - e.pageY * 2) / 100;
      
      parallaxRef.current.style.transform = `translateX(${x}px) translateY(${y}px)`;
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  
  return (
    <section className="relative h-screen flex items-center overflow-hidden" id="hero">
      {/* Background Image with parallax effect */}
      <div 
        ref={parallaxRef}
        className="absolute inset-0 z-0 overflow-hidden"
      >
        <img 
          src={LargeLogo}
          alt="Background water"
          className="absolute w-full h-full object-cover"
          style={{
            filter: 'brightness(0.7)',
            transform: 'scale(1.1)'
          }}
        />
      </div>
      
      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-black/70 z-1" />
      
      {/* Animated wave pattern */}
      <div className="absolute inset-0 z-2 opacity-20">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="absolute bottom-0 w-full">
          <path fill="#ffffff" fillOpacity="1" d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,229.3C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" className="animate-pulse"></path>
        </svg>
      </div>
      
      {/* Content */}
      <div className="container mx-auto px-4 z-10 text-white">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-4 fade-in">
            <span className="text-gradient">Premium</span> Fishing Equipment
          </h1>
          <p className="text-xl md:text-2xl mb-8 fade-in-delay-1">
            Professional grade fishing stands and accessories for the passionate angler
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 fade-in-delay-2">
            <a 
              href="#products" 
              className="btn-shine bg-primary hover:bg-primary/90 text-white py-3 px-8 rounded-md font-medium transition-all duration-300 inline-block text-center shadow-lg hover:-translate-y-1"
            >
              View Products
            </a>
            <a 
              href="#contact" 
              className="ripple-bg bg-secondary/80 backdrop-blur-sm hover:bg-secondary text-white py-3 px-8 rounded-md font-medium transition-all duration-300 inline-block text-center border border-white/30"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
      
      {/* Scroll Down Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce z-10 fade-in-delay-3">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection; 